import { rodnecislo as y } from "rodnecislo";
import x from "camelcase-keys";
import B from "snakecase-keys";
import s from "dayjs";
class I {
  /**
   * Uploads file to the server. You cannot use this function in node.js environment.
   * @param uploadUrl Url may starts with slash;
   * @param payload Payload contains file and userId;
   * @returns Response from the server or throws Error object with cause property = response from the server;
   */
  static async uploadFile(e, n) {
    const r = await fetch(e, {
      body: n.file,
      method: "PUT",
      headers: {
        "Content-Type": n.file.type,
        "x-amz-meta-user-id": n.userId ? n.userId.toString() : "0"
      }
    });
    if (r.status >= 200 && r.status < 300)
      return r;
    throw new Error(r.statusText || "UNKNOWN_ERROR", {
      cause: r
    });
  }
}
const pt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FilesApi: I
}, Symbol.toStringTag, { value: "Module" }));
var _ = /* @__PURE__ */ ((t) => (t.KomercniBanka = "0100", t.CeskoslovenskaObchodniBanka = "0300", t.MonetaMoneyBank = "0600", t.CeskaNarodniBanka = "0710", t.CeskaSporitelna = "0800", t.FioBanka = "2010", t.Cifin = "2060", t.TrinityBank = "2070", t.HypotecniBanka = "2100", t.PenezniDum = "2200", t.Artesa = "2220", t.BankaCreditas = "2250", t.Ney = "2260", t.PodnikatelskaDruzstevniZalozna = "2275", t.CitibankEurope = "2600", t.UniCreditBank = "2700", t.AirBank = "3030", t.BNPParibasPersonalFinance = "3050", t.PKO = "3060", t.INGBank = "3500", t.MaxBanka = "4000", t.NarodniRozvojovaBanka = "4300", t.Raiffeisenbank = "5500", t.JAndTBanka = "5800", t.PPFBanka = "6000", t.EquaBank = "6100", t.COMMERZBANK = "6200", t.MBank = "6210", t.BNPParibas = "6300", t.Partners = "6363", t.VseobecnaUverovaBanka = "6700", t.Sberbank = "6800", t.DeutscheBank = "7910", t.RaiffeisenStavebniSporitelna = "7950", t.CSOBStavebniSporitelna = "7960", t.MonetaStavebniSporitelna = "7970", t.ModraPyramidaStavebniSporitelna = "7990", t.VolksbankRaiffeisenbank = "8030", t.Oberbank = "8040", t.StavebniSporitelnaCeskeSporitelny = "8060", t.CeskaExportniBanka = "8090", t.HSBCContinentalEurope = "8150", t.SparkasseOberlausitzNiederschlesien = "8190", t.FASFinanceCompany = "8198", t.MoneyPoloEurope = "8199", t.PRIVATBANKDerRaiffeisenlandesbank = "8200", t.PaymentExecution = "8220", t.ABAPAY = "8230", t.DruzstevniZaloznaKredit = "8240", t.BankOfChina = "8250", t.BankOfCommunications = "8255", t.IndustrialAndCommercialBankOfChina = "8265", t.FairplayPay = "8270", t.BEfekt = "8280", t.BusinessCredit = "8291", t.MercuriusPartners = "8293", t.BESTPAY = "8299", t.FerratumBank = "8500", t))(_ || {});
const vt = {
  "0100": "Komerční banka, a.s.",
  "0300": "Československá obchodní banka, a. s.",
  "0600": "MONETA Money Bank, a.s.",
  "0710": "ČESKÁ NÁRODNÍ BANKA",
  "0800": "Česká spořitelna, a.s.",
  2010: "Fio banka, a.s.",
  2060: "Citfin, spořitelní družstvo",
  2070: "TRINITY BANK a.s.",
  2100: "Hypoteční banka,",
  2200: "Peněžní dům, spořitelní",
  2220: "Artesa, spořitelní družstvo",
  2250: "Banka CREDITAS a.s.",
  2260: "NEY spořitelní",
  2275: "Podnikatelská družstevní záložna",
  2600: "Citibank Europe plc, organizační složka",
  2700: "UniCredit Bank Czech Republic and Slovakia, a.s.",
  3030: "Air Bank a.s.",
  3050: "BNP Paribas Personal Finance SA, odštěpný závod",
  3060: "PKO BP S.A., Czech Branch",
  3500: "ING Bank N.V.",
  4e3: "Max banka a.s.",
  4300: "Národní rozvojová banka, a.s.",
  5500: "Raiffeisenbank a.s.",
  5800: "J&T BANKA, a.s.",
  6e3: "PPF banka a.s.",
  6100: "Equa Bank a. s. (nyní Raiffeisenbank, a.s.)",
  6200: "COMMERZBANK Aktiengesellschaft, pobočka Praha",
  6210: "mBank S.A., organizační složka",
  6300: "BNP Paribas S.A., pobočka Česká republika",
  6363: "Partners Banka, a.s.",
  6700: "Všeobecná úverová banka a.s., pobočka Praha",
  6800: "Sberbank CZ, a.s. v likvidaci",
  7910: "Deutsche Bank Aktiengesellschaft Filiale Prag, organizační složka",
  7950: "Raiffeisen stavební spořitelna",
  7960: "ČSOB Stavební spořitelna,",
  7970: "MONETA Stavební Spořitelna, a.s.",
  7990: "Modrá pyramida stavební spořitelna,",
  8030: "Volksbank Raiffeisenbank Nordoberpfalz eG pobočka Cheb",
  8040: "Oberbank AG pobočka Česká republika",
  8060: "Stavební spořitelna České spořitelny,",
  8090: "Česká exportní banka, a.s.",
  8150: "HSBC Continental Europe, Czech Republic",
  8190: "Sparkasse",
  8198: "FAS finance company s.r.o.",
  8199: "MoneyPolo Europe s.r.o.",
  8200: "PRIVAT BANK der Raiffeisenlandesbank OberösterreichAktiengesellschaft, pobočka Česká republika",
  8220: "Payment execution s.r.o.",
  8230: "ABAPAY s.r.o.",
  8240: "Družstevní záložna Kredit, v likvidaci",
  8250: "Bank of China (CEE) Ltd. Prague Branch",
  8255: "Bank of Communications Co., Ltd., Prague Branch odštěpný závod",
  8265: "Industrial and Commercial Bank of China Limited, Prague Branch,odštěpný závod",
  8270: "Fairplay Pay s.r.o.",
  8280: "B-Efekt a.s.",
  8291: "Business Credit s.r.o.",
  8293: "Mercurius partners s.r.o.",
  8299: "BESTPAY s.r.o.",
  8500: "Ferratum Bank plc"
};
async function Yt(t, e) {
  return (await Promise.all(t.map(async (r) => await e(r) ? r : null))).filter(Boolean);
}
function Dt(t) {
  const [e = "", n = ""] = (t == null ? void 0 : t.split("/")) ?? [];
  return {
    accountNumber: e,
    bankCode: n
  };
}
function gt(t) {
  return `${t.accountNumber}/${t.bankCode}`;
}
function Mt(t) {
  return y(t).birthDate();
}
var w = /* @__PURE__ */ ((t) => (t.thousand = "thousand", t.million = "million", t.billion = "billion", t.trillion = "trillion", t.e = "e", t.default = "", t))(w || {});
const U = {
  "": "",
  thousand: "tis",
  million: "mil",
  billion: "mld",
  trillion: "bil",
  e: "e"
};
function Nt(t, e = U) {
  const n = {
    value: t,
    suffixKey: ""
  };
  if (Math.abs(t) < 1e4)
    return n;
  const r = t < 0;
  n.value = Math.abs(t);
  const o = Math.floor(Math.log10(n.value) / 3 || 0);
  if (o === 0)
    return n;
  const l = Object.values(e)[o], c = 10 ** (o * 3), i = (n.value / c).toFixed(1);
  return n.value = Number(i), n.suffixKey = l ?? "", r && (n.value = -n.value), n;
}
function kt(t) {
  return B(t, { deep: !0 });
}
function St(t) {
  return x(t, { deep: !0 });
}
var $ = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function L(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var T = { exports: {} };
(function(t, e) {
  (function(n, r) {
    t.exports = r();
  })($, function() {
    var n = "month", r = "quarter";
    return function(o, l) {
      var c = l.prototype;
      c.quarter = function(u) {
        return this.$utils().u(u) ? Math.ceil((this.month() + 1) / 3) : this.month(this.month() % 3 + 3 * (u - 1));
      };
      var f = c.add;
      c.add = function(u, d) {
        return u = Number(u), this.$utils().p(d) === r ? this.add(3 * u, n) : f.bind(this)(u, d);
      };
      var i = c.startOf;
      c.startOf = function(u, d) {
        var m = this.$utils(), g = !!m.u(d) || d;
        if (m.p(u) === r) {
          var D = this.quarter() - 1;
          return g ? this.month(3 * D).startOf(n).startOf("day") : this.month(3 * D + 2).endOf(n).endOf("day");
        }
        return i.bind(this)(u, d);
      };
    };
  });
})(T);
var j = T.exports;
const q = /* @__PURE__ */ L(j);
var R = { exports: {} };
(function(t, e) {
  (function(n, r) {
    t.exports = r();
  })($, function() {
    var n = "minute", r = /[+-]\d\d(?::?\d\d)?/g, o = /([+-]|\d\d)/g;
    return function(l, c, f) {
      var i = c.prototype;
      f.utc = function(a) {
        var h = { date: a, utc: !0, args: arguments };
        return new c(h);
      }, i.utc = function(a) {
        var h = f(this.toDate(), { locale: this.$L, utc: !0 });
        return a ? h.add(this.utcOffset(), n) : h;
      }, i.local = function() {
        return f(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var u = i.parse;
      i.parse = function(a) {
        a.utc && (this.$u = !0), this.$utils().u(a.$offset) || (this.$offset = a.$offset), u.call(this, a);
      };
      var d = i.init;
      i.init = function() {
        if (this.$u) {
          var a = this.$d;
          this.$y = a.getUTCFullYear(), this.$M = a.getUTCMonth(), this.$D = a.getUTCDate(), this.$W = a.getUTCDay(), this.$H = a.getUTCHours(), this.$m = a.getUTCMinutes(), this.$s = a.getUTCSeconds(), this.$ms = a.getUTCMilliseconds();
        } else d.call(this);
      };
      var m = i.utcOffset;
      i.utcOffset = function(a, h) {
        var p = this.$utils().u;
        if (p(a)) return this.$u ? 0 : p(this.$offset) ? m.call(this) : this.$offset;
        if (typeof a == "string" && (a = function(M) {
          M === void 0 && (M = "");
          var O = M.match(r);
          if (!O) return null;
          var N = ("" + O[0]).match(o) || ["-", 0, 0], H = N[0], k = 60 * +N[1] + +N[2];
          return k === 0 ? 0 : H === "+" ? k : -k;
        }(a), a === null)) return this;
        var v = Math.abs(a) <= 16 ? 60 * a : a, b = this;
        if (h) return b.$offset = v, b.$u = a === 0, b;
        if (a !== 0) {
          var A = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (b = this.local().add(v + A, n)).$offset = v, b.$x.$localOffset = A;
        } else b = this.utc();
        return b;
      };
      var g = i.format;
      i.format = function(a) {
        var h = a || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return g.call(this, h);
      }, i.valueOf = function() {
        var a = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * a;
      }, i.isUTC = function() {
        return !!this.$u;
      }, i.toISOString = function() {
        return this.toDate().toISOString();
      }, i.toString = function() {
        return this.toDate().toUTCString();
      };
      var D = i.toDate;
      i.toDate = function(a) {
        return a === "s" && this.$offset ? f(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : D.call(this);
      };
      var P = i.diff;
      i.diff = function(a, h, p) {
        if (a && this.$u === a.$u) return P.call(this, a, h, p);
        var v = this.local(), b = f(a).local();
        return P.call(v, b, h, p);
      };
    };
  });
})(R);
var K = R.exports;
const V = /* @__PURE__ */ L(K);
s.extend(q);
s.extend(V);
var Q = /* @__PURE__ */ ((t) => (t.Daily = "DAILY", t.Monthly = "MONTHLY", t.Quarterly = "QUARTERLY", t.Halfyearly = "HALFYEARLY", t.Yearly = "YEARLY", t))(Q || {});
function Pt(t, e) {
  switch (e) {
    case "MONTHLY":
      return s(t).subtract(1, "month");
    case "QUARTERLY":
      return s(t).subtract(1, "quarter");
    case "HALFYEARLY":
      return s(t).subtract(6, "month");
    case "YEARLY":
      return s(t).subtract(1, "year");
    default:
      return null;
  }
}
function Z(t) {
  let e = "day";
  switch (t) {
    case "DAILY":
      e = "day";
      break;
    case "MONTHLY":
      e = "month";
      break;
    case "QUARTERLY":
      e = "quarter";
      break;
    case "HALFYEARLY":
      e = "month";
      break;
    case "YEARLY":
      e = "year";
      break;
    default:
      e = "day";
      break;
  }
  return e;
}
function E(t) {
  return s(t).quarter();
}
function F(t, e) {
  const n = (t - 1) * 3, r = new Date(e, n, 1);
  return s(r);
}
function G(t, e) {
  if (t === "MONTHLY")
    return e.getDate() === 1 ? e : s(e).set("date", 1).add(1, "month").utc(!0).toDate();
  if (t === "QUARTERLY") {
    if (s(e).startOf("quarter").utc(!0).isSame(e))
      return e;
    const n = e.getFullYear(), r = E(e), o = F(r, n);
    return s(o).set("date", 1).add(1, "quarter").utc(!0).toDate();
  }
  if (t === "HALFYEARLY") {
    const n = e.getMonth() < 6, r = s(e).set("date", 1).set("month", n ? 0 : 6);
    return s(e).utc(!0).isSame(r.utc(!0)) ? e : r.add(6, "month").utc(!0).toDate();
  }
  if (t === "YEARLY") {
    const n = s(e).set("date", 1).set("month", 0);
    return s(e).utc(!0).isSame(n.utc(!0)) ? e : n.add(1, "year").toDate();
  }
  return e;
}
function W(t, e) {
  if (t === "MONTHLY")
    return s(e).set("date", 1).add(1, "month").toDate();
  if (t === "QUARTERLY") {
    const n = e.getFullYear(), r = E(e), o = F(r, n);
    return s(o).set("date", 1).add(1, "quarter").toDate();
  }
  if (t === "HALFYEARLY") {
    const n = e.getMonth() < 6;
    return s(e).set("date", 1).set("month", n ? 0 : 6).add(6, "month").toDate();
  }
  return t === "YEARLY" ? s(e).set("date", 1).set("month", 0).add(1, "year").toDate() : s(e).add(1, "day").toDate();
}
function At(t, e) {
  const { periodicy: n, interestStartDate: r, maturityDate: o } = t, l = s(G(n, o)), c = Z(n);
  if (s(r).isSame(l, c))
    return [];
  let f = 0, i = s(r), u = i.isBefore(l, c);
  const d = [];
  for (; u; ) {
    if (f > 0) {
      i = s(W(n, i.toDate()));
      const m = {
        beginningPaymentPeriod: i.utc(!0).set("hour", 0).toDate()
      };
      d.push({
        ...m,
        ...e ? e(m) : {}
      });
    }
    u = i.isBefore(l, c), f++;
  }
  return d;
}
function Ot(t, { min: e, max: n, step: r }) {
  const o = r ? Math.floor(t / r) * r : t;
  return o < e ? e : o > n ? n : o;
}
function yt(t, e = !1) {
  const n = new Intl.NumberFormat("cs", {
    maximumFractionDigits: e ? 0 : 2,
    minimumFractionDigits: e ? 0 : 2
  }).format(t);
  return n === "NaN" ? "0.00" : n;
}
const J = {
  name: "cs",
  // name String
  weekdays: "Neděle_Pondělí_Úterý_Středa_Čtvrtek_Pátek_Sobota".split("_"),
  weekdaysShort: "Ne_Po_Út_St_Čt_Pá_So".split("_"),
  weekdaysMin: "Ne_Po_Út_St_Čt_Pá_So".split("_"),
  weekStart: 1,
  yearStart: 1,
  months: "leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec".split("_"),
  // months Array
  monthsShort: "led_úno_bře_dub_kvě_čer_čvc_srp_zář_říj_lis_pro".split("_"),
  ordinal: (t) => `${t}.`,
  formats: {
    // abbreviated format options allowing localization
    LTS: "H:mm:ss",
    LT: "H:mm",
    L: "DD.MM.YYYY",
    LL: "D. MMMM YYYY",
    LLL: "D. MMMM YYYY H:mm",
    LLLL: "dddd D. MMMM YYYY H:mm",
    // lowercase/short, optional formats for localization
    l: "D. M. YYYY",
    ll: "D. MMM YYYY",
    lll: "D. MMM YYYY H:mm",
    llll: "ddd D. MMM YYYY H:mm"
  },
  relativeTime: {
    // relative time format strings, keep %s %d as the same
    future: "za %s",
    // e.g. za 2 hodiny, %s been replaced with 2 hodiny
    past: "před %s",
    s: "pár sekund",
    m: "minuta",
    mm: "%d minut",
    h: "hodina",
    hh: "%d hodin",
    // e.g. 2 hodiny, %d been replaced with 2
    d: "den",
    dd: "%d dní",
    M: "měsíc",
    MM: "%d měsíců",
    y: "rok",
    yy: "%d let"
  },
  meridiem: (t) => t >= 12 ? "odpoledne" : "dopoledne"
}, _t = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  localeObjectCs: J
}, Symbol.toStringTag, { value: "Module" }));
function Y(t) {
  return typeof t == "object" ? Object.keys(t).length > 0 : typeof t == "string" && t.trim().length > 0;
}
function X(t) {
  return t ? !Number.isNaN(t.getTime()) : !1;
}
function C(t) {
  return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-z\-0-9]+\.)+[a-z]{2,}))$/i.test(t);
}
function tt(t) {
  return /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[#?!@$%^&*-]).{8,}$/.test(t);
}
function et(t) {
  return /^-?\d+(\.\d+)?$/.test(t);
}
function nt(t) {
  return /^-?\d+$/.test(t);
}
function rt(t, e) {
  return e > 0 && t.startsWith("0") ? !1 : Number(t) >= e;
}
function at(t, e) {
  return Number(t) <= e;
}
function it(t, e = 2) {
  const n = t.split(".")[1];
  return !n || n.length <= e;
}
function S(t) {
  if (!t || t.includes(" ") || !Number.isInteger(Number(t)))
    return !1;
  const e = [6, 3, 7, 9, 10, 5, 8, 4, 2, 1];
  return t.split("").reduce((r, o, l) => r + Number(o) * e[l], 0) % 11 === 0;
}
function z(t) {
  const e = t.split("-"), n = e.length === 2 ? e[0] : "", r = e.length === 2 ? e[1] : e[0];
  return !r || !Number.isInteger(Number(r)) || !Number.isInteger(Number(n)) || n && n.length > 6 || r.length < 2 || r.length > 10 || Number(r) < 11 || n && !S(n) ? !1 : S(r);
}
function st(t) {
  return t ? z(t.accountNumber) && Object.values(_).includes(t.bankCode) : !1;
}
function ot(t) {
  return /^(\+(420|421))? ?[1-9]\d{2} ?\d{3} ?\d{3}$/.test(t);
}
function ut(t, e) {
  const n = y(t);
  if (!e)
    return n.isValid();
  const r = n.birthDate();
  return n.isValid() && r.getDate() === e.getDate() && r.getMonth() === e.getMonth() && r.getFullYear() === e.getFullYear();
}
function lt(t) {
  if (t.length !== 8)
    return !1;
  const e = t.split("").map((r) => Number(r)), n = e.pop();
  return (11 - e.reduce((r, o, l) => r + o * (8 - l), 0) % 11) % 10 === n;
}
function ct(t) {
  return Y(t.firstLine) && Y(t.secondLine) && Y(t.zip) && Y(t.state);
}
function ft(t) {
  return !!(t.birthDate.birthNumber && t.birthDate.birthDate);
}
const $t = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bankAccountNumber: z,
  bankAccountValidator: st,
  isIntegerValidator: nt,
  isNumberValidator: et,
  maxValidator: at,
  maximumDecimals: it,
  minValidator: rt,
  validateAddressDetailsRequired: ct,
  validateBankNumber: S,
  validateBirthNumber: ut,
  validateBirthNumberRequired: ft,
  validateEmail: C,
  validateIco: lt,
  validatePassword: tt,
  validatePhone: ot,
  validateRequired: Y,
  validateRequiredDate: X
}, Symbol.toStringTag, { value: "Module" }));
export {
  _ as BankCodes,
  Q as PeriodicyEnum,
  w as SuffixKeys,
  pt as api,
  Yt as asyncArrayFilter,
  Dt as bankAccountFromString,
  gt as bankAccountToString,
  vt as bankTranslations,
  Nt as getAbbreviationNumber,
  Mt as getBirthDateFromBirthNumber,
  G as getLastPaymentDateByPeriod,
  W as getNextPaymentDateByPeriod,
  At as getPaymentSchedule,
  Pt as getPeriodDateByDate,
  E as getQuarterNumberByDate,
  F as getQuarterStart,
  Ot as roundToNearest,
  U as suffixKeysDefault,
  St as toCamelCase,
  kt as toSnackCase,
  _t as translations,
  yt as useMoneyFormat,
  $t as validators
};
